import { Form, message } from 'antd';
import axios from 'axios';
import { useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';

import PPPageHeader from '../../components/pageHeader/PPPageHeader';
import SaleForm from './SaleForm';

const ModalAddSale = () => {
  const location = useLocation();
  const history = useHistory();
  const productDetail = location?.state?.product ?? {};
  const [form] = Form.useForm();
  const [submitting, setSubmitting] = useState(false);

  const { price, title, baseSku, productSku, category } = productDetail;

  const formInitialVals = {
    priceBeforeSale: price,
    title,
  };

  /** Хямдралын таб руу буцна — шинээр үүсгэсэн хямдрал тэндээ харагдана */
  const saleTab = {
    pathname: `/merchant/products/${productDetail?._id}`,
    search: '?tab=sale',
  };

  const onFinish = async (values) => {
    const body = {
      ...values,
      // Сонгосон дуусах өдрийн 23:59 хүртэл хямдрал үргэлжилнэ
      startAt: values.dateRange?.[0]?.clone().startOf('day'),
      endAt: values.dateRange?.[1]?.clone().endOf('day'),
      salePercent: 0,
      fromThirdParty: false,
      baseSku,
      productSku,
      category,
    };

    setSubmitting(true);
    try {
      const { data } = await axios.post('/api/v1.0/productSale', body);

      if (data.statusCode === 200) {
        message.success('Хямдрал амжилттай үүслээ');
        form.resetFields();
        history.push(saleTab);
      }
    } catch (error) {
      // Алдааны мэдэгдлийг axios interceptor (App.js) аль хэдийн гаргасан
      console.error('Create product sale error: ', error);
    } finally {
      setSubmitting(false);
    }
  };

  const routes = [
    {
      to: { pathname: '/merchant/product/list' },
      breadcrumbName: 'Бараа',
    },
    {
      to: saleTab,
      breadcrumbName: 'Нэгж бараа',
    },
    {
      breadcrumbName: 'Хямдрал үүсгэх',
    },
  ];

  return (
    <>
      <PPPageHeader
        title="Хямдрал үүсгэх"
        breadcrumb={{ routes }}
        onBack={() => history.push(saleTab)}
      />

      <SaleForm
        form={form}
        id={productDetail?._id}
        product={productDetail}
        onFinish={onFinish}
        submitting={submitting}
        submitText="Хямдрал үүсгэх"
        initialValues={formInitialVals}
      />
    </>
  );
};

export default ModalAddSale;
